module.exports = __webpack_public_path__ + "media/images/emblems/Rheineck-coat_of_arms-be1b4c2d5c3e1ba7f5d266f38dfa6f21.svg";